import React from 'react';
import { useThemeUI, Box, Grid } from 'theme-ui';
import { Logo, Animation, DataList, Form, Heading, DecisionInput, Icon, Card } from '@loanpal/lumos__core';
import { useFormikContext } from 'formik';

var LogoBar = function LogoBar() {
  var _colors$gradients;

  var _useThemeUI = useThemeUI(),
      colors = _useThemeUI.theme.colors;

  return React.createElement(React.Fragment, null, React.createElement(Box, {
    as: "header",
    sx: {
      display: 'flex',
      '@media screen and (max-width: 80em)': {
        display: 'none'
      },
      maxWidth: 480,
      width: '100%',
      bg: 'primary.d3',
      // @ts-ignore
      background: (colors === null || colors === void 0 ? void 0 : (_colors$gradients = colors.gradients) === null || _colors$gradients === void 0 ? void 0 : _colors$gradients.secondary) || (colors === null || colors === void 0 ? void 0 : colors.primary),
      position: 'relative',
      overflow: 'hidden',
      justifyContent: 'center',
      color: 'text.negative',
      minHeight: '100vh'
    }
  }, React.createElement(Box, {
    as: "h1",
    mt: 72
  }, React.createElement(Logo, {
    invert: true
  })), React.createElement(Box, {
    variant: "logo.heroIcon"
  }, React.createElement(Logo, {
    invert: true,
    "aria-hidden": "true",
    variant: "icon"
  }))), React.createElement(Box, {
    as: "header",
    sx: {
      display: 'none',
      '@media screen and (max-width: 80em)': {
        display: 'flex'
      },
      bg: 'primary.d3',
      px: 3,
      py: 1,
      height: 56
    }
  }, React.createElement(Logo, {
    invert: true,
    size: "sm"
  })));
};

var HeroSidebar = function HeroSidebar(_ref) {
  var children = _ref.children;
  return React.createElement(Box, {
    sx: {
      bg: 'neutral.l4'
    }
  }, React.createElement(Box, {
    sx: {
      maxWidth: 1440,
      mx: 'auto',
      minHeight: 'calc(100vh - 56px'
    }
  }, React.createElement(Box, {
    as: "section",
    sx: {
      display: 'flex',
      '@media screen and (max-width: 80em)': {
        display: 'block'
      },
      mx: 'auto'
    }
  }, React.createElement(LogoBar, null), React.createElement(Box, {
    sx: {
      width: '100%',
      px: 4
    }
  }, children))));
};

var LogoBar$1 = function LogoBar(_ref) {
  var _colors$gradients;

  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'white' : _ref$variant;

  var _useThemeUI = useThemeUI(),
      colors = _useThemeUI.theme.colors;

  var isVariantSuccess = variant === 'success';
  var backgroundColor = isVariantSuccess || variant === 'neutral' ? 'neutral.l4' : 'white';
  return React.createElement(Box, {
    sx: {
      bg: backgroundColor
    }
  }, isVariantSuccess && React.createElement(Grid, {
    columns: 2,
    sx: {
      position: 'absolute',
      width: '100%',
      maxWidth: '1440px'
    }
  }, React.createElement(Animation, {
    variant: "confetti",
    sx: {
      height: '100vh'
    },
    loop: false
  }), React.createElement(Animation, {
    variant: "confetti",
    sx: {
      height: '100vh'
    },
    loop: false
  })), React.createElement(Box, {
    as: "header",
    sx: {
      bg: 'primary.d3',
      width: '100%',
      display: 'flex',
      '@media screen and (max-width: 80em)': {
        display: 'none'
      },
      alignItems: 'center',
      justifyContent: 'flex-start',
      height: 160,
      background: (colors === null || colors === void 0 ? void 0 : (_colors$gradients = colors.gradients) === null || _colors$gradients === void 0 ? void 0 : _colors$gradients.secondary) || (colors === null || colors === void 0 ? void 0 : colors.primary),
      position: 'relative'
    }
  }, React.createElement(Box, {
    variant: "logo.barIcon"
  }, React.createElement(Logo, {
    invert: true,
    "aria-hidden": "true",
    variant: "icon"
  })), React.createElement(Box, {
    as: "h1",
    sx: {
      maxWidth: 896,
      mx: 'auto',
      width: '100%',
      px: 3
    }
  }, React.createElement(Logo, {
    invert: true
  }))), React.createElement(Box, {
    as: "header",
    sx: {
      display: 'none',
      '@media screen and (max-width: 80em)': {
        display: 'flex'
      },
      bg: 'primary.d3',
      px: 3,
      py: 1,
      height: 56,
      position: isVariantSuccess ? 'relative' : 'static'
    }
  }, React.createElement(Logo, {
    invert: true,
    size: "sm"
  })), React.createElement(Box, {
    sx: {
      maxWidth: 896,
      mx: 'auto',
      p: 3,
      minHeight: 'calc(100vh - 160px)',
      bg: backgroundColor
    }
  }, isVariantSuccess ? React.createElement(Box, {
    sx: {
      position: 'relative'
    }
  }, children) : children));
};

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _excluded = ["sections", "sx"],
    _excluded2 = ["children", "sections", "sx", "sidebarProps"];

var isDefinitionSection = function isDefinitionSection(section) {
  return Array.isArray(section.definition);
};

var DetailSidebar = function DetailSidebar(_ref) {
  var sections = _ref.sections,
      sx = _ref.sx,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var sectionStyle = {
    borderTop: '1px solid',
    borderColor: 'neutral.l3',
    mt: 3,
    pt: 3,
    pb: 0
  };
  var sectionRendering = sections.map(function (_ref2) {
    var id = _ref2.id,
        section = _ref2.section;

    if (isDefinitionSection(section)) {
      return React.createElement(Box, {
        sx: sectionStyle,
        key: id
      }, section.prefix && section.prefix, React.createElement(DataList, {
        columns: 1,
        items: section.definition
      }), section.suffix && section.suffix);
    }

    return React.createElement(Box, {
      sx: sectionStyle,
      key: id
    }, section);
  });
  return React.createElement(Box, Object.assign({
    as: "aside",
    sx: _extends({
      bg: 'white',
      p: 3,
      '& > div:first-of-type': {
        borderTop: 'none',
        pt: 0,
        mt: 0
      }
    }, sx)
  }, rest), sectionRendering);
};

var InfoSidebar = function InfoSidebar(_ref3) {
  var children = _ref3.children,
      sections = _ref3.sections,
      sx = _ref3.sx,
      sidebarProps = _ref3.sidebarProps,
      props = _objectWithoutPropertiesLoose(_ref3, _excluded2);

  return React.createElement(Box, {
    sx: {
      bg: 'neutral.l4'
    }
  }, React.createElement(Box, {
    sx: {
      maxWidth: 1440,
      mx: 'auto',
      minHeight: 'calc(100vh - 56px)'
    }
  }, React.createElement(Grid, {
    gap: 0,
    columns: "1fr 480px",
    sx: {
      '@media (max-width: 1200px)': {
        gridTemplateColumns: '1fr 340px'
      },
      '@media (max-width: 940px)': {
        gridTemplateColumns: '1fr',
        '& > aside': {
          display: 'none'
        }
      },
      minHeight: 'calc(100vh - 56px)'
    }
  }, React.createElement(Box, Object.assign({
    sx: _extends({
      p: 3,
      mb: 2
    }, sx)
  }, props), children), React.createElement(DetailSidebar, Object.assign({
    sections: sections
  }, sidebarProps)))));
};

var DetailsView = function DetailsView(_ref) {
  var children = _ref.children,
      details = _ref.details;
  return React.createElement(Box, {
    sx: {
      bg: 'white'
    }
  }, React.createElement(Box, {
    sx: {
      bg: 'neutral.l4'
    }
  }, React.createElement(Box, {
    sx: {
      maxWidth: 1440,
      mx: 'auto',
      py: 3,
      px: 3
    }
  }, details)), React.createElement(Box, {
    sx: {
      maxWidth: 1440,
      mx: 'auto',
      pb: 3,
      px: 3
    }
  }, children));
};

var BaseView = function BaseView(_ref) {
  var children = _ref.children,
      _ref$sx = _ref.sx,
      sx = _ref$sx === void 0 ? {} : _ref$sx;
  return React.createElement(Box, {
    sx: {
      bg: 'neutral.l4'
    }
  }, React.createElement(Box, {
    sx: _extends({
      maxWidth: 1440,
      mx: 'auto',
      py: 3,
      px: 2,
      minHeight: '100vh'
    }, sx)
  }, children));
};

var SidebarItem = function SidebarItem(_ref) {
  var name = _ref.name,
      title = _ref.title,
      value = _ref.value,
      selected = _ref.selected,
      handleSelect = _ref.handleSelect,
      allowMissing = _ref.allowMissing,
      allowPass = _ref.allowPass,
      allowFail = _ref.allowFail;
  return React.createElement(Grid, {
    columns: "116px 1fr",
    sx: {
      borderBottom: '1px solid',
      borderColor: 'neutral.l3',
      alignItems: 'center',
      pl: 3,
      fieldset: {
        mb: 1
      },
      bg: selected ? 'primary.l3' : 'white',
      ':hover': {
        bg: selected ? 'primary.l3' : 'primary.l4'
      }
    }
  }, React.createElement(DecisionInput, {
    name: name,
    label: title,
    allowMissing: allowMissing,
    allowPass: allowPass,
    allowFail: allowFail
  }), React.createElement(Box, {
    role: "switch",
    "aria-checked": selected,
    as: "button",
    // @ts-ignore Box is not accepting `type` but without it browser thinks that `button` is type="submit"
    type: "button",
    onClick: function onClick() {
      return handleSelect(name);
    },
    sx: {
      bg: 'transparent',
      border: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      textAlign: 'left',
      py: 2
    }
  }, React.createElement(Box, {
    sx: {
      ml: 2
    }
  }, React.createElement(Box, {
    variant: "text.small",
    sx: {
      color: 'neutral.base',
      fontWeight: 500
    }
  }, title), React.createElement(Box, {
    variant: "text.h6",
    sx: {
      p: 0
    }
  }, value || '-')), React.createElement(Icon, {
    variant: "angle-right",
    color: selected ? 'neutral.d1' : 'neutral.l1'
  })));
};

var DecisionListener = function DecisionListener(_ref2) {
  var handleChange = _ref2.handleChange;

  var _useFormikContext = useFormikContext(),
      values = _useFormikContext.values;

  React.useEffect(function () {
    handleChange(values);
  }, [values]);
  return null;
};

var DecisionView = function DecisionView(_ref3) {
  var _items$find;

  var onDecisionChange = _ref3.onDecisionChange,
      initialValues = _ref3.initialValues,
      items = _ref3.items,
      title = _ref3.title;

  var _React$useState = React.useState(),
      selectedPane = _React$useState[0],
      selectPane = _React$useState[1];

  var activePanel = selectedPane && ((_items$find = items.find(function (x) {
    return selectedPane === x.name;
  })) === null || _items$find === void 0 ? void 0 : _items$find.panel);
  var emptyState = React.createElement(Box, {
    sx: {
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bg: 'neutral.l4'
    }
  }, "Select an area at left to review.");
  return React.createElement(Grid, {
    columns: "minmax(400px, 712px) minmax(600px, 1fr)",
    gap: 0,
    sx: {
      position: 'relative',
      '@media screen and (min-width: 480px) and (min-height: 480px)': {
        overflowY: 'hidden'
      }
    }
  }, React.createElement(Box, {
    sx: {
      borderRight: '1px solid',
      borderColor: 'neutral.l3',
      height: '100%',
      overflow: 'scroll',
      position: 'relative'
    }
  }, React.createElement(Form, {
    onSubmit: console.log,
    initialValues: initialValues
  }, React.createElement(DecisionListener, {
    handleChange: onDecisionChange
  }), title && React.createElement(Heading, {
    as: "div",
    variant: "h4",
    sx: {
      p: 3
    }
  }, title), React.createElement(Box, {
    sx: {
      '& > div:first-of-type': {
        borderTop: '1px solid',
        borderColor: 'neutral.l3'
      }
    }
  }, items.map(function (x) {
    return React.createElement(SidebarItem, Object.assign({
      key: x.name
    }, x, {
      selected: x.name === selectedPane,
      handleSelect: selectPane
    }));
  })))), React.createElement(Box, {
    sx: {
      m: 3,
      overflow: 'scroll',
      position: 'relative'
    }
  }, activePanel || emptyState));
};

var SidebarItem$1 = function SidebarItem(_ref) {
  var name = _ref.name,
      title = _ref.title,
      selected = _ref.selected,
      handleSelect = _ref.handleSelect;
  return React.createElement(Grid, {
    columns: "1fr",
    sx: {
      borderBottom: '1px solid',
      borderColor: 'neutral.l3',
      alignItems: 'center',
      fieldset: {
        mb: 1
      },
      bg: selected ? 'primary.l3' : 'white',
      ':hover': {
        bg: selected ? 'primary.l3' : 'primary.l4'
      }
    }
  }, React.createElement(Box, {
    role: "switch",
    "aria-checked": selected,
    as: "button",
    onClick: function onClick() {
      return handleSelect(name);
    },
    sx: {
      pl: 2,
      bg: 'transparent',
      border: 'none',
      display: 'grid',
      gridTemplateColumns: '1fr 24px',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: 'pointer',
      textAlign: 'left',
      py: 2
    }
  }, React.createElement(Box, {
    sx: {
      ml: 2
    }
  }, React.createElement(Box, {
    variant: "text.small",
    sx: {
      color: 'neutral.base',
      fontWeight: 500
    }
  }, title)), React.createElement(Icon, {
    variant: "angle-right",
    color: selected ? 'neutral.d1' : 'neutral.l1'
  })));
};

var DecisionView$1 = function DecisionView(_ref2) {
  var _items$find;

  var items = _ref2.items,
      title = _ref2.title,
      emptyContainer = _ref2.emptyContainer;

  var _React$useState = React.useState(),
      selectedPane = _React$useState[0],
      selectPane = _React$useState[1];

  var activePanel = selectedPane && ((_items$find = items.find(function (x) {
    return selectedPane === x.name;
  })) === null || _items$find === void 0 ? void 0 : _items$find.panel);
  var emptyState = React.createElement(Box, {
    sx: {
      height: '100%',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bg: 'neutral.l4'
    }
  }, emptyContainer || 'Select an area at left to view');
  return React.createElement(Grid, {
    columns: "minmax(400px, 712px) minmax(600px, 1fr)",
    gap: 0
  }, React.createElement(Box, {
    sx: {
      borderRight: '1px solid',
      borderColor: 'neutral.l3',
      height: '100vh'
    }
  }, title && React.createElement(Heading, {
    as: "div",
    variant: "h4",
    sx: {
      p: 3
    }
  }, title), React.createElement(Box, {
    sx: {
      '& > div:first-of-type': {
        borderTop: '1px solid',
        borderColor: 'neutral.l3'
      }
    }
  }, items.map(function (x) {
    return React.createElement(SidebarItem$1, Object.assign({}, x, {
      key: x.name.replace(/ /g, '-'),
      selected: x.name === selectedPane,
      handleSelect: selectPane
    }));
  }))), React.createElement(Box, {
    sx: {
      height: '100vh',
      m: 3
    }
  }, activePanel || emptyState));
};

var IconList = function IconList(_ref) {
  var children = _ref.children,
      icon = _ref.icon;
  return React.createElement(Grid, {
    as: "li",
    gap: "12px",
    columns: "32px 1fr",
    sx: {
      alignItems: 'center',
      mb: '12px'
    }
  }, React.createElement(Box, {
    sx: {
      width: 32,
      height: 32,
      bg: 'primary.l4',
      borderRadius: 'full',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, React.createElement(Icon, {
    variant: icon,
    color: "primary.d1",
    size: "sm"
  })), React.createElement("div", null, children));
};

var ErrorPage = function ErrorPage() {
  var _useThemeUI = useThemeUI(),
      url = _useThemeUI.theme.url;

  return React.createElement(React.Fragment, null, React.createElement(Box, {
    sx: {
      pt: 6,
      '@media screen and (max-width: 80em)': {
        pt: 4
      }
    }
  }, React.createElement(Box, {
    sx: {
      width: '100%',
      mx: 'auto',
      maxWidth: 500
    }
  }, React.createElement(Card, {
    variant: "float",
    sx: {
      px: 4
    }
  }, React.createElement(Heading, {
    variant: "h3",
    as: "h2",
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Icon, {
    variant: "color-warning",
    sx: {
      mr: 3
    },
    size: "md"
  }), "Well this doesn't seem right."), React.createElement(Box, {
    sx: {
      mt: 1,
      pb: 3,
      mb: 3,
      borderBottom: '1px solid',
      borderColor: 'neutral.l3'
    }
  }, "It looks like we've encountered an unexpected problem."), React.createElement("section", null, React.createElement(Heading, {
    variant: "h5",
    as: "div"
  }, "What should I do?"), React.createElement(Box, {
    as: "ul",
    sx: {
      p: 0,
      mt: '12px',
      listStyleType: 'none',
      ml: -2
    }
  }, React.createElement(IconList, {
    icon: "refresh"
  }, "Try refreshing, we automatically track these issues."), React.createElement(IconList, {
    icon: "phone"
  }, "If the issue continues, please\xA0", React.createElement("a", {
    href: url + "/contact-us"
  }, "contact us."))))))));
};

var ErrorPage$1 = function ErrorPage() {
  var _useThemeUI = useThemeUI(),
      url = _useThemeUI.theme.url;

  return React.createElement(React.Fragment, null, React.createElement(Box, {
    sx: {
      pt: 6,
      '@media screen and (max-width: 80em)': {
        pt: 4
      }
    }
  }, React.createElement(Box, {
    sx: {
      width: '100%',
      mx: 'auto',
      maxWidth: 500
    }
  }, React.createElement(Card, {
    variant: "float",
    sx: {
      px: 4,
      pb: 4
    }
  }, React.createElement(Heading, {
    variant: "h3",
    as: "h2",
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, "Page not found!"), React.createElement(Box, {
    sx: {
      mt: 1,
      pb: 3,
      mb: 3,
      borderBottom: '1px solid',
      borderColor: 'neutral.l3'
    }
  }, "Sorry, but the page you were looking for could not be found."), React.createElement("section", null, React.createElement(Heading, {
    variant: "h5",
    as: "div"
  }, "What should I do?"), "You can ", React.createElement("a", {
    href: "/"
  }, "return to our front page"), ", or\xA0", React.createElement("a", {
    href: url + "/contact-us"
  }, "contact us"), " if you can't find what you're looking for")))));
};

var ErrorPage$2 = function ErrorPage() {
  var _useThemeUI = useThemeUI(),
      url = _useThemeUI.theme.url;

  return React.createElement(React.Fragment, null, React.createElement(Box, {
    sx: {
      pt: 6,
      '@media screen and (max-width: 80em)': {
        pt: 4
      }
    }
  }, React.createElement(Box, {
    sx: {
      width: '100%',
      mx: 'auto',
      maxWidth: 500
    }
  }, React.createElement(Card, {
    variant: "float",
    sx: {
      px: 4
    }
  }, React.createElement(Heading, {
    variant: "h3",
    as: "h2",
    sx: {
      display: 'flex',
      alignItems: 'center'
    }
  }, React.createElement(Icon, {
    variant: "color-info",
    sx: {
      mr: 3
    },
    size: "md"
  }), "Unauthorized"), React.createElement(Box, {
    sx: {
      mt: 1,
      pb: 3,
      mb: 3,
      borderBottom: '1px solid',
      borderColor: 'neutral.l3'
    }
  }, "It looks like you're not able to access this due to permissions."), React.createElement("section", null, React.createElement(Heading, {
    variant: "h5",
    as: "div"
  }, "What should I do?"), React.createElement(Box, {
    as: "ul",
    sx: {
      p: 0,
      mt: '12px',
      listStyleType: 'none',
      ml: -2
    }
  }, React.createElement(IconList, {
    icon: "user"
  }, "If you feel this is an error, contact your administrator to change your role for different access permissions."), React.createElement(IconList, {
    icon: "phone"
  }, "If you should have access to this and your role is correct, please\xA0", React.createElement("a", {
    href: url + "/contact-us"
  }, "contact us."))))))));
};

export { BaseView, DecisionView, DetailsView, ErrorPage, LogoBar$1 as HeroBarView, HeroSidebar as HeroView, InfoSidebar as InfoView, ErrorPage$1 as NotFoundPage, DecisionView$1 as SidebarView, ErrorPage$2 as UnauthorizedPage };
//# sourceMappingURL=lumos__layout.esm.js.map
